/**
 * Stacked WEEK progress bar: 完了 (teal) + 着手中 (orange) + 未着手 (grey).
 * Shared by the group header and the row inside its dropdown.
 */

import { TCurriculumGroupCounts } from "@/features/learning-progress/utils/curriculum-groups";
import { divider, orange, primary } from "@/theme/colors";
import { Box, Stack } from "@mui/material";
import { FC, memo } from "react";

/** One color per WEEK status — reused by the chips and the legend squares */
export const WEEK_STATUS_COLORS = {
  completed: primary[500],
  inProgress: orange[80],
  notStarted: divider.middle,
} as const;

const BAR_HEIGHT = 10;

type TCurriculumProgressBarProps = {
  counts: TCurriculumGroupCounts;
};

export const CurriculumProgressBar: FC<TCurriculumProgressBarProps> = memo(({ counts }) => {
  const total = Math.max(counts.total, 1);
  const completedWidth = (counts.completed / total) * 100;
  const inProgressWidth = (counts.inProgress / total) * 100;

  return (
    <Stack
      direction="row"
      sx={{ flex: 1, minWidth: 0, height: BAR_HEIGHT, borderRadius: "999px", overflow: "hidden", bgcolor: WEEK_STATUS_COLORS.notStarted }}
    >
      <Box sx={{ width: `${completedWidth}%`, bgcolor: WEEK_STATUS_COLORS.completed }} />
      <Box sx={{ width: `${inProgressWidth}%`, bgcolor: WEEK_STATUS_COLORS.inProgress }} />
    </Stack>
  );
});
CurriculumProgressBar.displayName = "CurriculumProgressBar";
